<script setup lang="ts">
import { isYcError } from '@yc/api-client'
import { computed, ref } from 'vue'

const props = defineProps<{ error: unknown }>()

const copied = ref(false)

const yc = computed(() => (isYcError(props.error) ? props.error : null))
const message = computed(() => {
  if (yc.value) return yc.value.message
  if (typeof props.error === 'string') return props.error
  return props.error instanceof Error ? props.error.message : '请求失败'
})
const traceId = computed(() => yc.value?.traceId ?? '')

async function copyTrace(): Promise<void> {
  if (!traceId.value) return
  try {
    await navigator.clipboard.writeText(traceId.value)
    copied.value = true
    setTimeout(() => (copied.value = false), 1500)
  } catch {
    copied.value = false
  }
}
</script>

<template>
  <div class="yc-trace">
    <span class="yc-trace__msg">{{ message }}</span>
    <el-button v-if="traceId" size="small" text type="primary" @click="copyTrace">
      {{ copied ? '已复制' : `trace_id: ${traceId}` }}
    </el-button>
  </div>
</template>

<style scoped lang="scss">
.yc-trace {
  display: inline-flex;
  gap: var(--yc-space-2);
  align-items: center;
  flex-wrap: wrap;
}
</style>